<template>
	<div class="content">
		<div class="md-layout">
			<div class="md-layout-item md-medium-size-10 md-size-33"></div>
			<div class="md-layout-item md-medium-size-80 md-size-33 middle">
				<h2 style="text-align: center;">សូមដោះសោដើម្បីប្រើប្រាស់ប្រព័ន្ធ</h2>
				<md-card class="card">
					<md-card-content>
						<form @submit.prevent="login()">
							<div class="md-layout">
								<div class="md-layout-item md-small-size-100 md-size-100">
									<md-field>
										<label>អ្នកប្រើប្រាស់</label>
										<md-input v-model="user.username" type="text" @keyup="checkValidation()"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-100">
									<md-field>
										<label>ពាក្យសំងាត់</label>
										<md-input v-model="user.password" type="password" @keyup="checkValidation()"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-size-100 text-right">
									<md-button :class="{'md-raised': true, 'md-primary': isValid}" :disabled="!isValid"
										type="submit">ដោះសោ</md-button>
								</div>
							</div>
						</form>
					</md-card-content>
				</md-card>
			</div>
			<div class="md-layout-item md-medium-size-25 md-size-33"></div>
		</div>
	</div>
</template>

<script>
	export default {
		created() {

			this.$cookie.delete('auth');
		},
		data() {
			return {
				isValid: false,
				user: {
					username: "",
					password: ""
				}
			}
		},
		methods: {
			login() {
				let username = this.user.username
				let password = this.user.password

				this.isValid = false
				this.user.password = ""
				this.checkValidation();

				this.$http.post(this.config.api + "/admin/login", {username, password}).then(res => {

					if (res.body.status == 'success') {
						if(res.body.data.account_type == "sa") {
							this.$cookie.set('lock', "sa", 30);
							this.$store.state.authentication.lock = false;
						} else {
								this.$notification.notify({
									message: "Incorrect username or password.",
									icon: 'error',
									type: 'danger'
								})
						}
					}
				})
				// if (username == 'admin' && password == 'testingtesting') {
				// 	this.$store.state.authentication.loggedIn = true;
				// } else {
				// 	this.$notification.notify({
				// 		message: "Incorrect username or password",
				// 		icon: 'error',
				// 		type: 'danger'
				// 	})
				// }
			},
			checkValidation() {
				if (this.user.username.length > 2 && this.user.password.length > 2) {
					this.isValid = true
				} else {
					this.isValid = false
				}
			}
		}
	}
</script>

<style scoped>
	.card {
		margin-top: 80px;
	}

	.middle {
		position: relative;
		margin-top: 12vh;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Lock.vue